import React from "react";
import { Redirect } from "react-router-dom";
import { Grid } from "semantic-ui-react";
import styled from "styled-components";
import { Constants, Paths } from "../Constants";
import BaseComponent from "./BaseComponent";
import AppHeaderSmall from "./common/AppHeaderSmall";
import Footer from "./common/Footer";
import MainContentWrapper from "./common/MainContentWrapper";
import PillButton from "./common/PillButton";
import SFCookieConsent from "./common/SFCookieConsent";
import SFLoader from "./common/SFLoader";
import SiteWrapper from "./common/SiteWrapper";
import TabBar from "./common/TabBar";
import TestCard from "./common/TestCard";

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

const ButtonGroup = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: row;
`;

class Follower extends BaseComponent {
  constructor() {
    super();
    this.state = {
      subscriber: null,
      showConfirmCancel: false,
      pending: false,
      subscribed: false,
      showLoader: false,
    };

    this.deleteSubscription = this.deleteSubscription.bind(this);
    this.getSubscriptionStatus = this.getSubscriptionStatus.bind(this);
    this.requestSubscription = this.requestSubscription.bind(this);
  }

  async componentDidMount() {
    this.setState({
      subscriber: this.props.location.state.subscriber,
      showLoader: true,
    });
    await this.getSubscriptionStatus();
    this.setState({ showLoader: false });
  }

  async getSubscriptionStatus() {
    if (!(await this.checkLogin())) {
      return;
    }

    this.setState({ showLoader: true });
    const response = await this.safeFunApi.getSubscriptionStatus(
      this.props.location.state.subscriber.sF_ConsumerId
    );
    this.setState({ showLoader: false });
    if (!response.data.success) {
      this.errorManager.addError("Failed to cancel the pending follow request");
      this.forceUpdate();
      return;
    }

    this.setState({
      pending: response.data.pending,
      subscribed: response.data.subscribed,
    });
  }

  async deleteSubscription() {
    if (!(await this.checkLogin())) {
      return;
    }

    this.setState({ showLoader: true });
    const response = await this.safeFunApi.deleteSubscription(
      this.state.subscriber.sF_ConsumerSubscriptionId
    );
    this.setState({ showLoader: false });
    if (!response.data.success) {
      this.errorManager.addError("Failed to cancel the pending follow request");
      this.forceUpdate();
      return;
    }
    this.redirect(Paths.PEOPLE);
  }

  async requestSubscription() {
    if (!(await this.checkLogin())) {
      return;
    }

    this.setState({ showLoader: true });
    const response = await this.safeFunApi.requestSubscription(
      this.state.subscriber.sF_ConsumerId
    );
    this.setState({ showLoader: false });

    if (!response.data.success) {
      this.errorManager.addError("Failed to request to follow this user");
      this.forceUpdate();
      return;
    }
    this.setState({ pending: true });
  }

  render() {
    return (
      <SiteWrapper>
        {this.state.redirectPath ? (
          <Redirect
            to={{
              pathname: this.state.redirectPath,
              search: this.state.redirectSearch,
              state: this.state.redirectState,
            }}
          />
        ) : null}

        <AppHeaderSmall title="Follower" />
        <SFLoader active={this.state.showLoader} />
        <MainContentWrapper>
          <TabBar people />

          <Wrapper>
            <Grid columns={1} style={{ width: "400px", margin: "0" }}>
              <Grid.Row>
                <Grid.Column style={{ margin: "0", padding: "0" }}>
                  {this.state.subscriber ? (
                    <TestCard
                      currentUser={false}
                      consumer={this.state.subscriber}
                    />
                  ) : null}
                </Grid.Column>
              </Grid.Row>

              <ButtonGroup>
                {!this.state.subscribed && !this.state.pending ? (
                  <PillButton
                    style={{ width: "150px" }}
                    primary
                    onClick={() => {
                      this.requestSubscription();
                    }}
                  >
                    Follow Back
                  </PillButton>
                ) : (
                  <PillButton
                    style={{
                      width: "150px",
                      backgroundColor: "white",
                      borderColor: "lightgray",
                      borderWidth: 2,
                      borderStyle: "solid",
                    }}
                    disabled
                  >
                    {this.state.pending ? "Pending" : "Following"}
                  </PillButton>
                )}
              </ButtonGroup>

              <ButtonGroup>
                {this.state.showConfirmCancel ? (
                  <>
                    <PillButton
                      style={{ width: "150px", marginTop: 20 }}
                      primary
                      onClick={() => {
                        this.deleteSubscription();
                      }}
                    >
                      Confirm
                    </PillButton>
                    <PillButton
                      style={{
                        width: "150px",
                        backgroundColor: "white",
                        borderColor: "#1cbff2",
                        borderWidth: 2,
                        borderStyle: "solid",
                      }}
                      onClick={() => {
                        this.setState({ showConfirmCancel: false });
                      }}
                    >
                      Cancel
                    </PillButton>
                  </>
                ) : (
                  <PillButton
                    style={{ width: "150px", marginTop: 20 }}
                    primary
                    onClick={() => {
                      this.setState({ showConfirmCancel: true });
                    }}
                  >
                    Remove
                  </PillButton>
                )}
              </ButtonGroup>

              <Grid.Row>
                <Grid.Column style={{ textAlign: "center" }}>
                  <a
                    href={Constants.TESTING_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Click to learn more about our testing
                    <br /> philosophy and SafeWindows
                  </a>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Wrapper>
        </MainContentWrapper>
        <Footer />
        <SFCookieConsent />
      </SiteWrapper>
    );
  }
}

export default Follower;
